import { awsCredentials } from '../../../config.js'

const aws = require('aws-sdk')
aws.config = awsCredentials
const ses = new aws.SES()

const sendEmail = ({sourceEmail, destinationEmails, ccEmails, templateName, templateData, onSuccess, onError}) => {
  const params = {
    "Source": sourceEmail,
    "Destination": {
      "CcAddresses": ccEmails,
      "ToAddresses": destinationEmails
    },
    "Template": templateName,
    "TemplateData": JSON.stringify(templateData)
  }

  ses.sendTemplatedEmail(params, (email_err, email_data) => {
    if (email_err && onError) {
      onError()
    } else if (!email_err && onSuccess) {
      onSuccess()
    }
  })
}


export default sendEmail;
